import React, {useEffect, useState } from "react";
import { Button, Layout, Menu, Dropdown } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  UserOutlined,
  LogoutOutlined,
  HomeOutlined,
  CopyOutlined,
  EditOutlined,
  DesktopOutlined,
  FileTextOutlined,
  LaptopOutlined,
  StockOutlined,
  SettingOutlined,
  TeamOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  TableOutlined,
} from "@ant-design/icons";
import "../styles/DefaultLayout.css";
import { getUserRole, capitalize } from "../utils/auth";
import { jwtDecode } from "jwt-decode";
import logo from '../assets/images/mkfnblogo.png'; // adjust path as needed
const { Header, Content, Sider } = Layout;

const SubMenu = Menu.SubMenu;

const MinimalLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const toggle = () => {
    setCollapsed(!collapsed);
  };


  const [isUserHovered, setIsUserHovered] = useState(false);
  const userRole = getUserRole();

  // Handle logout logic
  const handleLogout = () => {
    // Remove 'auth' item from localStorage
    localStorage.removeItem("auth");

    // Navigate to login page
    navigate("/login");
  };

  const menu = (
    <Menu>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const menuItems = [
    {
      key: "1",
      label: "Logout",
      onClick: handleLogout,
    },
  ];


  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId); // Set the current user

        // Navigate only if the user is on an invalid page
        if (window.location.pathname === "/login") {
          navigate("/"); // Redirect to the default page only if on login
        }
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
        navigate("/login"); // Redirect to login if token is invalid
      }
    } else {
      navigate("/login"); // Redirect to login if no auth is found
    }
  }, [navigate]);

  useEffect(() => {
   const settingsChildren = [
      "/general",
      "/tables",
      "/category",
      "/items",
      "/inventory",
      "/setTax",
      "/setService",
      "/invoice",
      "/staff",
      "/clockInOut",
      "/productIcon",
    ];
    // const posChildren = [
    //   "/",
    //   "/bills",
    // ];
    const posChildren = ["/", "/cashiers", "/staffTransactionsRecord"];
    const recordChildren = ["/transactionRecord"];

    if (posChildren.includes(location.pathname)) {
      setOpenKeys(["POS"]); // Open the POS submenu
    }else if (settingsChildren.includes(location.pathname)) {
      setOpenKeys(["SubMenu"]); // Open the Settings submenu
    } else if (recordChildren.includes(location.pathname)) {
      setOpenKeys(["Record"]); // Open the Record submenu
    } else {
      setOpenKeys([]); // Close it if not on a settings child
    }
  }, [location.pathname]);

  // Handle submenu open/close
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));

    // If clicking on POS submenu, toggle it
    if (latestOpenKey === "POS") {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
    // If clicking on Settings submenu, toggle it
    else if (latestOpenKey === "SubMenu") {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
    // If clicking on Record submenu, toggle it
    else if (latestOpenKey === "Record") {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
    // Otherwise, just follow normal behavior
    else {
      setOpenKeys(keys);
    }
  };

  return (
    <Layout>
      <Sider
        theme="light"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={180}
        collapsedWidth={80}
        style={{
          background: 'white',
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
          borderRight: '1px solid #f0f0f0',
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          transition: 'width 0.3s',
          fontFamily: 'Inter, sans-serif',
          // width: collapsed ? 80 : 200, // Fixed sidebar width
        }}
      >
        {/* <div className="logo">
          <h1 className="text-center text-light font-weight-bold mt-4 collapsed-sidebar-header-title">
            Makan F&B
          </h1>
        </div> */}
        <div className="logo text-center my-4 collapsed-sidebar-header-title">
          <img
            src={logo}
            alt="Makan F&B"
            className="sidebar-logo"
            style={{ width: collapsed ? '80px' : '100px', transition: 'width 0.3s' }}
          />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultSelectedKeys={window.location.pathname}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          style={{
            backgroundColor: 'transparent',
            color: '#333',
            fontWeight: 500,
          }}
          theme="light"
        >
          <SubMenu
            key="POS"
            title="P.O.S"
            icon={<HomeOutlined />}
          >
            <Menu.Item key="/" //icon={<HomeOutlined />}
            >
              <Link to="/">Table</Link>
            </Menu.Item>

            <Menu.Item
              key="/cashiers" //icon={<EditOutlined />}
            >
              <Link to="/cashiers">Cashiers</Link>
            </Menu.Item>

            {/* {userRole === "staff" && ( */}
            <Menu.Item key="/staffTransactionsRecord">
              <Link to="/staffTransactionsRecord">Transaction</Link>
            </Menu.Item>
          </SubMenu>

          {userRole === "admin" && (
            <SubMenu key="Record" title="Record" icon={<CopyOutlined />}>
              {/* <Menu.Item key="/einvoice">
                <Link to="/einvoice">E-Invoice</Link>
              </Menu.Item> */}
              <Menu.Item key="/transactionRecord">
                <Link to="/transactionRecord">Transaction</Link>
              </Menu.Item>
            </SubMenu>
          )}

          <Menu.Item key="/report" icon={<FileTextOutlined />}>
            <Link to="/report">Report</Link>
          </Menu.Item>

          <Menu.Item key="/secondDisplay" icon={<LaptopOutlined />}>
            <a href={`/secondDisplay?userId=${localStorage.getItem('userId')}`} target="_blank" rel="noopener noreferrer">
              Second Display
            </a>
          </Menu.Item>

          <Menu.Item key="/kitchen" icon={<DesktopOutlined />}>
            <Link to="/kitchen">Kitchen</Link>
          </Menu.Item>

          {userRole === "admin" && (
            <>
              <SubMenu
                key="SubMenu"
                title="Settings"
                icon={<SettingOutlined />}
              >
                <Menu.Item key="/general">
                  <Link to="/general">General</Link>
                </Menu.Item>

                <Menu.Item key="/tables">
                  <Link to="/tables">Tables</Link>
                </Menu.Item>
                <Menu.Item key="/category" //icon={<AppstoreOutlined />}
                >
                  <Link to="/category">Category</Link>
                </Menu.Item>
                <Menu.Item key="/items" //icon={<MenuOutlined />}
                >
                  <Link to="/items">Menu</Link>
                </Menu.Item>
                <Menu.Item key="/inventory" //icon={<StockOutlined />}
                >
                  <Link to="/inventory">Inventory</Link>
                </Menu.Item>

                <Menu.Item key="/setTax">
                  <Link to="/setTax">Taxes</Link>
                </Menu.Item>
                <Menu.Item key="/setService">
                  <Link to="/setService">Services</Link>
                </Menu.Item>

                <Menu.Item
                  key="/invoice" //icon={<CopyOutlined />}
                >
                  <Link to="/invoice">Invoice</Link>
                </Menu.Item>

                <Menu.Item key="/staff" //icon={<UserOutlined />}
                >
                  <Link to="/staff">Staff</Link>
                </Menu.Item>
                <Menu.Item key="/clockInOut">
                  <Link to="/clockInOut">Attendance</Link>
                </Menu.Item>
                          <Menu.Item key="/productIcon">
                            <Link to="/productIcon"> Product Icon</Link>
                          </Menu.Item>

              </SubMenu>
                
              </>
          )}
        </Menu>
      </Sider>

      <Layout
        className="site-layout"
        style={{
          marginLeft: collapsed ? 80 : 200, // Sidebar margin
        }}
      >
        <Header
          className="site-layout-background"
          style={{
            marginLeft: "",
            margin: "0px 0px 0px",
            paddingRight: "34px",
            position: "fixed",
            width: collapsed ? "calc(100% - 80px)" : "calc(100% - 180px)", // Match sidebar width
            zIndex: 10,
            display: "flex", // 关键：使用 flex
            justifyContent: "flex-end", // 关键：将内容推到右边
            alignItems: "center", // 垂直居中
          }}
        >

          {/* hello admin */}
          <Dropdown menu={{ items: menuItems }} placement="bottomRight">
            <div 
                style={{ 
                display: 'flex', 
                alignItems: 'center',
                cursor: 'pointer',
                borderRadius: '4px',
                color: isUserHovered  ? 'rgb(229,103,23)' : 'black',
                transition: 'color 0.3s'
                }}
                onMouseEnter={() => setIsUserHovered(true)}
                onMouseLeave={() => setIsUserHovered(false)}
            >
              <UserOutlined style={{ marginRight: "5px", fontSize:"20px", verticalAlign: "middle" }} />
              <span>{currentUser ? capitalize(currentUser) : "User"}</span>
            </div>
          </Dropdown>
          
          {/* <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
            onOpenChange={(visible) => setMenuVisible(visible)}
          >
            <Button
              style={{
                float: "right",
                marginTop: "15px",
                marginRight: "10px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "5px",
                padding: "8px 20px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >

              <span>Hello, {currentUser || "User"}</span>
              <DownOutlined style={{ fontSize: '0px' }}
              /> 
              <span style={{ marginLeft: '8px', fontSize: '10px' }}>▼</span>           
              <svg
                style={{
                  marginLeft: "8px",
                  transform: menuVisible ? "rotate(0deg)" : "rotate(90deg)",
                  transition: "transform 0.3s ease",
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path fillRule="evenodd" d="M1.5 5.5l6.5 6.5 6.5-6.5h-13z" />
              </svg>
            </Button>
          </Dropdown> */}
        </Header>
        <Content
          className="site-layout-background"
          style={{
            //marginLeft: collapsed ? 80 : 200, // Match header margin
            margin: "64px 0px 24px",
            padding: 24,
            transition: "margin-left 0.2s ease", // Smooth transition when collapsing sidebar
            minHeight: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default MinimalLayout;
